/**
 * Browser-compatible storage utilities
 * Wraps storage-manager for client-side use
 * Uses IndexedDB for better performance and larger storage capacity
 */

import {
  IndexedDBBookStorage,
  IndexedDBReadingPositionStorage,
  IndexedDBBookmarkStorage,
  IndexedDBWrapper
} from '@legere/storage-manager';

let bookStorage: IndexedDBBookStorage | null = null;
let positionStorage: IndexedDBReadingPositionStorage | null = null;
let bookmarkStorage: IndexedDBBookmarkStorage | null = null;
let dbWrapper: IndexedDBWrapper | null = null;

function getDBWrapper(): IndexedDBWrapper {
  if (!dbWrapper) {
    dbWrapper = new IndexedDBWrapper();
  }
  return dbWrapper;
}

export function getBookStorage(): IndexedDBBookStorage {
  if (typeof window === 'undefined') {
    throw new Error('Storage can only be accessed in browser');
  }

  if (!bookStorage) {
    bookStorage = new IndexedDBBookStorage(getDBWrapper());
  }
  return bookStorage;
}

export function getPositionStorage(): IndexedDBReadingPositionStorage {
  if (typeof window === 'undefined') {
    throw new Error('Storage can only be accessed in browser');
  }

  if (!positionStorage) {
    positionStorage = new IndexedDBReadingPositionStorage(getDBWrapper());
  }
  return positionStorage;
}

export function getBookmarkStorage(): IndexedDBBookmarkStorage {
  if (typeof window === 'undefined') {
    throw new Error('Storage can only be accessed in browser');
  }

  if (!bookmarkStorage) {
    bookmarkStorage = new IndexedDBBookmarkStorage(getDBWrapper());
  }
  return bookmarkStorage;
}

// Alias for consistency with reading-position.ts usage
export const getReadingPositionStorage = getPositionStorage;
